import { render, staticRenderFns } from "./overview-cell-category.vue?vue&type=template&id=606de32b&scoped=true"
import script from "./overview-cell-category.vue?vue&type=script&lang=ts"
export * from "./overview-cell-category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606de32b",
  null
  
)

export default component.exports